import type { IconSvgObject } from './types';

const BracketsIcon: IconSvgObject = [
  ["path", { d: "M16 21C16.93 21 17.395 21 17.7765 20.8978C18.8117 20.6204 19.6204 19.8117 19.8978 18.7765C20 18.395 20 17.93 20 17V7C20 6.07003 20 5.60504 19.8978 5.22354C19.6204 4.18827 18.8117 3.37962 17.7765 3.10222C17.395 3 16.93 3 16 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 21C7.07003 21 6.60504 21 6.22354 20.8978C5.18827 20.6204 4.37962 19.8117 4.10222 18.7765C4 18.395 4 17.93 4 17V7C4 6.07003 4 5.60504 4.10222 5.22354C4.37962 4.18827 5.18827 3.37962 6.22354 3.10222C6.60504 3 7.07003 3 8 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default BracketsIcon;
